// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_1f7U7","pagination":"List_pagination_3CC0r","paginationText":"List_paginationText_3LHnr","paginationButton":"List_paginationButton_1dDzX"};